<template>
  <v-app-bar color="primary" fixed dark app>
    <v-toolbar-title class="ml-0">
      <v-app-bar-nav-icon @click.stop="handleDrawerToggle"></v-app-bar-nav-icon>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn icon @click="handleFullScreen()">
      <v-icon>fullscreen</v-icon>
    </v-btn>

    <lang-select></lang-select>

    <v-menu
      bottom
      left
      offset-y
      :nudge-bottom="10"
      transition="scale-transition"
    >
      <template v-slot:activator="{ on }">
        <v-btn text v-on="on" style="min-width: 48px; padding: 0">
          <v-avatar size="30px">
            <v-icon dark>account_circle</v-icon>
          </v-avatar>
          <span class="hidden-sm-and-down">{{ adminName }}</span>
        </v-btn>
      </template>
      <v-list class="pa-0">
        <v-list-item
          v-for="(item, index) in items"
          :to="!item.href ? { name: item.name } : null"
          @click="item.click"
          :disabled="item.disabled"
          :target="item.target"
          rel="noopener"
          :key="index"
        >
          <v-list-item-action v-if="item.icon">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-action>
            <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>
<script>
import Util from "@/util";
import LangSelect from "@/components/LangSelect";
import { mapGetters } from "vuex";

export default {
  name: "app-toolbar",
  components: {
    LangSelect
  },
  data: () => ({
    items: [
      {
        icon: "account_circle",
        name: "profile",
        title: "headerMenu.profile",
        click: e => {
          console.log(e);
        }
      },
      {
        icon: "fullscreen_exit",
        href: "#",
        title: "headerMenu.logout",
        click: () => {
          window.getApp.$emit("APP_LOGOUT");
        }
      }
    ]
  }),
  computed: {
    ...mapGetters(["currentUser"]),
    toolbarColor() {
      return this.$vuetify.options.extra.mainNav;
    },
    adminName() {
      if (this.currentUser) {
        return this.currentUser.full_name || this.currentUser.email;
      }
      return "Admin";
    }
  },
  methods: {
    handleDrawerToggle() {
      window.getApp.$emit("APP_DRAWER_TOGGLED");
    },
    handleFullScreen() {
      Util.toggleFullScreen();
    }
  },
  created() {
    this.$store.dispatch("fetchProfile").catch(() => {});
  }
};
</script>
